import { HOST_URL } from 'config';
import AjaxUtil from '../../../Js/AjaxHelper/AjaxUtil';
import * as ApiUrl from '../../../ApiHelper/ApiUrls';
import retry from 'common/Js/AjaxHelper/retry';

const SETTINGS_API = '/WebApp/Settings';

export default class api {
  static getMasterSlaves() {
    const url = HOST_URL + SETTINGS_API + '/GetMasterSlaves?_=' + Date();
    return retry(() => AjaxUtil.sendGet(url));
  }
  static selectMasterSlave(isMaster, slave, isGlobal) {
    const msUrl = HOST_URL + SETTINGS_API + '/SelectMasterSlave';
    const msGlobalUrl = ApiUrl.ApiEndPoints.GlobalMode.Settings.SelectMasterSlave;
    const url = isGlobal ? msGlobalUrl : msUrl;
    const body = { isMaster: isMaster, slave: slave };
    return AjaxUtil.genericSendPost(url, JSON.stringify(body));
  }

  /// Global management
  static getIsGlobalMode() {
    let url = ApiUrl.ApiEndPoints.Settings.GetIsGlobalMode;
    return retry(() => AjaxUtil.sendGet(url));
  }

  static getClientToken() {
    let url = ApiUrl.ApiEndPoints.PlantingUIjs.GetPlantingUiBundle;
    return AjaxUtil.sendGet(url);
  }
}
